<SocialTags
	pageTitle="Términos y Condiciones"
	urlPath="/terminos-y-condiciones/"
></SocialTags>

<style src="./style.scss">

</style>

<main id="dnsPageSignup" class="mbsc-grid d-ns-page tos-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
      selectedItem='signup'
			path={router.path}
		></MainMenu>
	</nav>

  <TermsText></TermsText>

	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import SocialTags from '@Components/SocialTags/index.svelte';
import MainMenu from '@Components/MainMenu/index.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import TermsText from '@Components/TermsText/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { Navigation, Utils, AWSAnalytics } from '@Services';

export let router = null;

const DEBUG = document.location.protocol === 'http:' ? true : false;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {});

onMount(async () =>{
	console.info('App ' + DEBUG + '::' + router.path);
	
  mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

	mobiscroll.page('.tos-page', {});
	
	Utils.scrollToTop();
});
</script>
